import Helper from "../../Helper";

import { MapboxCredentials } from "../Map/mapboxUpload";

export interface GeotiffResponse {
    geotiff: any;
    mapbox_credentials: any;
}

export function createGeotiff(
    projectToken: string,
    projectId: number,
    mapbox_credentials: MapboxCredentials
): Promise<GeotiffResponse> {
    const url = `/projects/${projectToken}/geotiff`;
    const options = {
        method: "POST",
        body: JSON.stringify({
            geotiff: {
                status: "importing",
                geotiff_name: `${projectId}_${Date.now()}`,
                mapbox_credentials: mapbox_credentials,
            },
        }),
    };
    return Helper.plotFetch(url, options).then((r) => r.json() as Promise<GeotiffResponse>);
}

export function updateGeotiffProgress(projectToken: string, progress: number, mapbox_credentials: MapboxCredentials) {
    const url = `/projects/${projectToken}/geotiff`;
    const options = {
        method: "PUT",
        body: JSON.stringify({
            geotiff: { progress, mapbox_credentials },
        }),
    };
    return Helper.plotFetch(url, options, true);
}

export function fetchGeotiff(projectToken: string): Promise<any> {
    const url = `/projects/${projectToken}/geotiff`;
    return Helper.plotFetch(url).then((r) => r.json());
}

export function deleteGeotiff(projectToken: string): Promise<any> {
    const url = `/projects/${projectToken}/geotiff`;
    const options = {
        method: "DELETE",
    };
    return Helper.plotFetch(url, options, true);
}

export function fetchMapboxUploadCredentials(projectToken: string): Promise<MapboxCredentials> {
    const url = `/projects/${projectToken}/mapbox_credentials`;

    return Helper.plotFetch(url)
        .then((r) => r.json())
        .then((data) => data.mapbox_credentials as MapboxCredentials);
}
